(() => {
  const selector = '.product__description.rte';

  function createButton(direction, label) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `description-image-carousel__button description-image-carousel__button--${direction}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = direction === 'previous' ? '&#8592;' : '&#8594;';
    return button;
  }

  function initialise(description) {
    if (!description || description.dataset.imageCarouselReady === 'true') return;

    const sourceImages = Array.from(description.querySelectorAll('img')).filter((image) => image.getAttribute('src'));
    if (sourceImages.length < 2) return;

    description.dataset.imageCarouselReady = 'true';

    const carousel = document.createElement('div');
    carousel.className = 'description-image-carousel';
    const track = document.createElement('div');
    track.className = 'description-image-carousel__track';
    track.setAttribute('aria-label', 'Product description images');
    const previous = createButton('previous', 'Previous description image');
    const next = createButton('next', 'Next description image');

    sourceImages.forEach((sourceImage) => {
      const slide = document.createElement('div');
      slide.className = 'description-image-carousel__slide';
      const image = sourceImage.cloneNode(true);
      image.removeAttribute('width');
      image.removeAttribute('height');
      image.loading = 'lazy';
      slide.appendChild(image);
      track.appendChild(slide);
      sourceImage.classList.add('description-image-carousel__source');
    });

    carousel.append(previous, track, next);
    description.insertBefore(carousel, description.firstChild);

    const updateButtons = () => {
      const maximum = track.scrollWidth - track.clientWidth - 2;
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maximum;
    };

    previous.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
  }

  function initialiseAll() {
    document.querySelectorAll(selector).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }
})();